import env from "../config/env";

export const apiURL = env.REACT_APP_BACKEND_URL;
